import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagGI = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F9F9F9",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 50c10.749 0 19.913-6.784 23.445-16.304H1.555C5.087 43.216 14.25 50 25 50ZM34.783 20.652V17.39h1.087v-2.174h-2.174v1.087h-2.174v-1.087h-2.174v2.174h1.087v3.26H28.26v-7.608h1.087V10.87h-2.174v1.086h-1.087V10.87h-2.174v1.086h-1.087V10.87h-2.174v2.173h1.087v7.609h-2.174V17.39h1.087v-2.174h-2.174v1.087h-2.174v-1.087h-2.173v2.174h1.086v3.26h-2.173v8.697h23.913v-8.696h-2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 28.26a3.26 3.26 0 0 0-1.087 6.336v4.534h-3.26v4.348h5.434v-8.882A3.262 3.262 0 0 0 25 28.261Zm0 4.348a1.087 1.087 0 1 1 0-2.174 1.087 1.087 0 0 1 0 2.174Z"
}));
FlagGI.displayName = 'FlagGI';
export default withFlagWrapper(FlagGI);
//# sourceMappingURL=index.js.map